import {memo} from 'react';

import styled from 'styled-components';

import {PriceLabel} from '~/shared/components/PriceLabels';
import {NumericFormats} from '~/shared/consts/checkoutConsts';
import {DetailsBox, Text, Sum} from '~/shared/components/UserTransactions/components/styled';

export const MobileDetailsBoxWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const BoldPriceLabel = styled(PriceLabel)`
  font-weight: bold;
`;

const MoneyCardDetail = ({daily, weekly, monthly, type, isMobile}) => {
  const showDaily = Boolean(daily);
  const showWeekly = Boolean(weekly && !(monthly && weekly && daily));
  const showMonthly = Boolean(monthly && !(monthly && weekly && daily));

  if (isMobile) {
    return (
      <>
        <MobileDetailsBoxWrapper>
          {showMonthly && (
            <DetailsBox isMobile>
              <Sum isMobile type={type}>
                <BoldPriceLabel price={monthly.sum} formatString={NumericFormats.hideZeroDecimals} />
              </Sum>
              <Text isMobile>{monthly.text}</Text>
            </DetailsBox>
          )}
          {showWeekly && (
            <DetailsBox isMobile>
              <Sum isMobile type={type}>
                <BoldPriceLabel price={weekly.sum} formatString={NumericFormats.hideZeroDecimals} />
              </Sum>
              <Text isMobile>{weekly.text}</Text>
            </DetailsBox>
          )}
          {showDaily && (
            <DetailsBox isMobile>
              <Sum isMobile type={type}>
                <BoldPriceLabel price={daily.sum} formatString={NumericFormats.hideZeroDecimals} />
              </Sum>
              <Text isMobile>{daily.text}</Text>
            </DetailsBox>
          )}
        </MobileDetailsBoxWrapper>
      </>
    );
  }

  return (
    <DetailsBox>
      {showMonthly && (
        <>
          <Sum type={type}>
            <PriceLabel price={monthly.sum} formatString={NumericFormats.hideZeroDecimals} bold />
          </Sum>
          <Text spaceDown={showWeekly || showDaily}>{monthly.text}</Text>
        </>
      )}
      {showWeekly && (
        <>
          <Sum type={type}>
            <PriceLabel price={weekly.sum} bold formatString={NumericFormats.hideZeroDecimals} />
          </Sum>
          <Text spaceDown={showDaily}>{weekly.text}</Text>
        </>
      )}
      {showDaily && (
        <>
          <Sum type={type}>
            <PriceLabel price={daily.sum} bold formatString={NumericFormats.hideZeroDecimals} />
          </Sum>
          <Text>{daily.text}</Text>
        </>
      )}
    </DetailsBox>
  );
};

export default memo(MoneyCardDetail);
